import { capitalizeFirstLetter, formatDate } from "helpers/utils.helper"
import { TableQuotationsStatuses } from "./TableQuotationsStatuses"
import { ButtonOptions } from "components/ui/buttons/ButtonOptions/ButtonOptions"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { Spin } from "components/ui/spin/Spin"
import { Dropdown } from "components/ui/dropdown/Dropdown"
import { ArrowIcon } from "components/ui/icons/quotations/ArrowIcon"
import { TableQuotationsDropdownItems } from "./TableQuotationsDropdownItems"
import type { TQuotationTableData } from "types/quotations.type"
import type { ColumnsType } from "antd/es/table"
import style from "./TableQuotations.module.scss"

const { linkSource, quotationName, editButton, editSpinner } = style

export const TableQuotationsColumns = (
	userIsNotFileOwner: boolean,
	renameQuotation: (quotationId: number) => void,
	editQuotation: (quotationId: number) => void,
	loadingQuotationId: number | null,
) => {
	const { getDropdownItems } = TableQuotationsDropdownItems(renameQuotation)

	const columns: ColumnsType<TQuotationTableData> = [
		{
			title: "NAME",
			dataIndex: "name",
			key: "name",
			render: (name) => <span className={quotationName}>{name}</span>,
		},
		{
			title: "CREATED AT",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (createdAt) => formatDate(createdAt, "yyyy-MM-dd'T'HH:mm:ssXXX", "MMM dd, HH:mm"),
		},
		{
			title: "SOURCE",
			dataIndex: "source",
			key: "source",
			render: (source) => (
				<span onClick={(e) => e.stopPropagation()}>
					<a href={source.url} target="_blank" className={linkSource}>
						{`${capitalizeFirstLetter(source.type)} ${formatDate(source.creation_datetime, "yyyy-MM-dd'T'HH:mm:ssXXX", "MMM dd, yyyy")}`}
						<ArrowIcon />
					</a>
				</span>
			),
		},
		{
			title: "STATUS",
			dataIndex: "status",
			key: "status",
			render: (status) => <TableQuotationsStatuses status={status} />,
		},
		{
			title: "SUBMITTED AT",
			dataIndex: "submittedAt",
			key: "submittedAt",
			render: (submittedAt) =>
				submittedAt ? formatDate(submittedAt, "yyyy-MM-dd'T'HH:mm:ssXXX", "MMM dd, HH:mm") : "-",
		},
	]

	// Edit + action columns are owner-only
	if (!userIsNotFileOwner) {
		columns.push({
			title: "",
			dataIndex: "edit",
			key: "edit",
			render: (_, record) =>
				record.status === "in_progress" ? (
					loadingQuotationId === record.key ? (
						<div className={editSpinner}>
							<Spin size="small" />
						</div>
					) : (
						<span onClick={(e) => e.stopPropagation()}>
							<ButtonSecondary
								className={editButton}
								type="button"
								submittable={loadingQuotationId === null}
								onClick={() => editQuotation(record.key)}
							>
								Edit
							</ButtonSecondary>
						</span>
					)
				) : null,
		})

		columns.push({
			title: "",
			dataIndex: "action",
			key: "action",
			render: (_, record) => {
				return (
					<span onClick={(e) => e.stopPropagation()}>
						<Dropdown items={getDropdownItems(record.key)}>
							<span>
								<ButtonOptions />
							</span>
						</Dropdown>
					</span>
				)
			},
		})
	}

	return columns
}
